import React, { useContext, useState } from "react";
import { CcRootContext } from "../conversionCenterRoot";
import { sortByPosition } from "../helpers/helpers";
import CcHeader from "../elements/ccHeader";
import CcList from "../elements/ccList";
import CcLinkButton from "../elements/ccLinkButton";
import { useEffect } from "react";

const WelcomeScreen = () => {
  const ctx = useContext(CcRootContext);
  const { details, video } = ctx.welcomeScreen;
  const [buttonsData, setButtonsData] = useState([]);

  useEffect(() => {
    setButtonsData(sortByPosition(ctx.sites.map((data) => ({
      btnData: data.welcomeScreenButton,
      speciality: data.specialtyName,
      contentType: data.contentType,
      id: data.id,
    }))));
  }, [ctx]);

  return(
    <>
      <CcHeader 
        details={details}
        video={video}
      />
      {buttonsData.length > 0 && (
        <CcList>
          {buttonsData.filter((btn) => btn.btnData.active).map((data) => <CcLinkButton key={data.speciality} data={data} />)}
        </CcList>
      )}
    </>
  );
};

export default WelcomeScreen;
